<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      {{ activeMenu }}
      <el-menu
        class="el-menu-wrap"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :text-color="variables.menuText"
        background-color="transparent"
        active-text-color="#FFF"
        unique-opened
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/assets/styles/variables.scss'
import Logo from './Logo'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(['sidebar']),
    ...mapState({
      leftDays: state => state.user.company_info.left_days
    }),
    routes() {
      const routes = this.$store.getters.routes
      // 根据是否过期判断是否有dashboard路由
      if (!this.leftDays) {
        routes.forEach(item => {
          if (item.path === '/') item.children = []
        })
      }
      return routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      return meta.type || path
    },
    showLogo() {
      return true
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
